function sineIn (t) {
  var v = Math.cos(t * Math.PI * 0.5)
  if (Math.abs(v) < 1e-14) return 1
  else return 1 - v
}

module.exports = sineIn



//////////////////
// WEBPACK FOOTER
// ./node_modules/eases/sine-in.js
// module id = 157
// module chunks = 0